import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { VizcfComponent } from './vizcf.component';
import { ImmovableSearchService } from './immovable-search.service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClientModule } from '@angular/common/http';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [
    VizcfComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    NgSelectModule,
    HttpClientModule,
    NgxDatatableModule,
    NgxSpinnerModule
  ],
  exports: [VizcfComponent],
  providers: [ImmovableSearchService],
  bootstrap: [VizcfComponent]
})
export class VizcfModule { }
